import { Module } from 'vuex';
import { EmpathizeState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { EMPATHIZE_ACTIONS } from './empathize.actions';
import { EMPATHIZE_GETTERS } from './empathize.getters';
import { EMPATHIZE_MUTATIONS } from './empathize.mutations';
import { getInitialEmpathizeState } from './empathize.state';

export const EMPATHIZE_MODULE: Module<EmpathizeState, RootStoreState> = {
  namespaced: true,
  actions: EMPATHIZE_ACTIONS,
  mutations: EMPATHIZE_MUTATIONS,
  getters: EMPATHIZE_GETTERS,
  state: getInitialEmpathizeState()
};
